// Mock auth is a local-dev convenience only. Gating on `DEV` (true only under the Vite dev
// server) guarantees a built bundle always uses real Auth0, even if the flag leaks into a
// build's env — a mock-auth build sends `mock-access-token`, which every real API rejects.
// eslint-disable-next-line turbo/no-undeclared-env-vars -- DEV is Vite's built-in flag, not an env var
export const isMockAuth = import.meta.env.DEV && import.meta.env.VITE_APP_USE_MOCK_AUTH === 'true'
